var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 114.78 84.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-9{fill:none;}.cls-1{clip-rule:evenodd;}.cls-3,.cls-9{stroke:#00af66;}.cls-3,.cls-4,.cls-9{stroke-linecap:round;stroke-linejoin:round;}.cls-3{stroke-width:2.17px;}.cls-4{stroke:#003820;stroke-width:2.43px;}.cls-5{clip-path:url(#clip-path);}.cls-6{clip-path:url(#clip-path-2);}.cls-7{fill:#00af66;}.cls-8{clip-path:url(#clip-path-3);}.cls-9{stroke-width:2.03px;stroke-dasharray:2.84 6.08;}.cls-10{clip-path:url(#clip-path-5);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-18.65 -33.79)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.43,105.83H23.94a1.23,1.23,0,0,1-1.23-1.23V60a1.23,1.23,0,0,1,1.23-1.24H50.43A1.23,1.23,0,0,1,51.66,60V104.6a1.23,1.23,0,0,1-1.23,1.23"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-18.65 -33.79)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 152.07,
    height: 152.07
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(-18.65 -33.79)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.34,92.38a10.87,10.87,0,1,1-10.87-10.87,10.87,10.87,0,0,1,10.87,10.87"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(-18.65 -33.79)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.85,81.24l3.86,2.23a1,1,0,0,1,0,1.73l-3.86,2.23a1,1,0,0,1-1.5-.87V82.11a1,1,0,0,1,1.5-.87"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "app") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fixed"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 87.19,
    y1: 1.08,
    x2: 88.87,
    y2: 18.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 92.87,
    y1: 61.91,
    x2: 94.79,
    y2: 81.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 88.81,
    y1: 18.52,
    x2: 93.08,
    y2: 61.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M129.7,76.65H96.52l2.87,36.59a2.85,2.85,0,0,0,2.84,2.68H124a2.86,2.86,0,0,0,2.85-2.68Z",
    transform: "translate(-18.65 -33.79)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 76.65,
    y1: 37.58,
    x2: 112.81,
    y2: 37.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M113.48,57.18A14.21,14.21,0,0,0,101.38,64",
    transform: "translate(-18.65 -33.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M94.89,71.38a18.67,18.67,0,0,1,37.33,0",
    transform: "translate(-18.65 -33.79)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1.22,
    y: 15.28,
    width: 35.4,
    height: 68.41,
    rx: 3.68,
    ry: 3.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 23.99,
    y1: 20.14,
    x2: 16.63,
    y2: 20.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 12.93,
    y1: 20.14,
    x2: 10.54,
    y2: 20.14
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 2.03,
    y: 22.98,
    width: 33.01,
    height: 51.09
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.68,111.9a2.4,2.4,0,1,1-2.4-2.41A2.41,2.41,0,0,1,39.68,111.9Z",
    transform: "translate(-18.65 -33.79)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 81.92,
    y: 45.69,
    width: 25.8,
    height: 25.8
  }))), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 42.99,
    y1: 50.56,
    x2: 62.46,
    y2: 50.56
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 63.67,
    y: 45.29,
    width: 9.91,
    height: 10.51
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp);
export default __webpack_public_path__ + "static/media/app.db239734eb18d9173db82ed0cfe5b118.svg";
export { ForwardRef as ReactComponent };